import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Referrer } from '../../../classes/referrer';
import { ReferrerService } from '../../../services/referrer';
import { HttpErrorResponse } from '@angular/common/http';
import { referrerEmailError, referrerNameError, referrerSurnameError } from '../../../utils/referrerValidation';

@Component({
    selector: 'app-referrer-create-modal',
    templateUrl: './referrer-create-modal.component.html',
    styleUrls: ['./referrer-create-modal.component.css']
})
export class ReferrerCreateModalComponent {
    referrer: Referrer = new Referrer();
    submitted: boolean = false;
    loadingCondition: boolean = false;
    formError: string = '';

    constructor(public activeModal: NgbActiveModal,
                private referrerService: ReferrerService) {
    }

    get nameError(): string | null {
        return this.submitted ? referrerNameError(this.referrer.Name) : null;
    }

    get surnameError(): string | null {
        return this.submitted ? referrerSurnameError(this.referrer.Surname) : null;
    }

    get emailError(): string | null {
        return this.submitted ? referrerEmailError(this.referrer.Email) : null;
    }

    createReferrer() {
        if (this.loadingCondition) {
            return;
        }
        this.submitted = true;
        this.formError = '';
        if (this.nameError || this.surnameError || this.emailError) {
            return;
        }
        this.referrer.Name = this.referrer.Name.trim();
        this.referrer.Surname = this.referrer.Surname.trim();
        this.referrer.Email = this.referrer.Email.trim();
        this.loadingCondition = true;
        this.referrerService.create(this.referrer)
            .subscribe({
                next: (referrerCreated: Referrer) => {
                    this.loadingCondition = false;
                    this.activeModal.close(referrerCreated);
                },
                error: (err: HttpErrorResponse) => {
                    this.loadingCondition = false;
                    this.formError = err.error?.message || 'Non è stato possibile creare il segnalatore.';
                }
            });
    }
}
